import { FC } from "react";
import cl from "classnames";
import styles from "./Search.module.scss";
import { SettingsButton } from "@/lib/ui/components/Buttons";
import { SearchInput } from "@/lib/ui/components/Input";
import { useTranslation } from "next-i18next";
import { IClassname } from "@/lib/types/classname";
import { modal } from "../Modal";
import { CatalogFilterModal } from "../../blocks/page-specific/Catalog/CatalogFilterModal";
import { useCatalogFilter } from "@/lib/hooks/useCatalogFilter";

interface ISearch extends IClassname {
  isInFilter?: boolean;
}
export const Search: FC<ISearch> = ({ className, isInFilter }) => {
  const {
    t,
    i18n: { language },
  } = useTranslation("index");
  const { query } = useCatalogFilter();
  return (
    <div
      className={cl(
        styles.search,
        className,
        !isInFilter ? styles["search--" + language] : "",
      )}
    >
      <SearchInput placeholder={t("search")} />
      <SettingsButton
        onClick={() => {
          modal.open(<CatalogFilterModal />, { isFilterModal: true });
        }}
        hasDot={!!Object.entries(query).length}
        className={cl(
          styles.search__button,
          isInFilter && styles["search__button--filter"],
        )}
      />
    </div>
  );
};
